export default __webpack_public_path__ + "static/media/responsive-icon1.6dd03fbb.png";